import Vue from "vue";

export const ControlRecords = {
  methods: {

  },
};
